<div class="wrapper-info">
  <button
    data-automation-id="info-toggle-button"
    #infoButton
    id="info-button"
    type="button"
    class="infobtn"
    attr.aria-label="{{ ariaLabelInfoButton }}"
    aria-controls="info-panel"
    [attr.aria-expanded]="isInfoVisible"
    (click)="handleInfoClick($event)"
    (keydown)="handleKeyDown($event)"
    (focusout)="handleFocusOut($event)"
    >
    <i class="dpg-icon dpg-icon-system-alert-info" aria-hidden="true"></i>
  </button>
  <div
    aria-live="polite"
    >
    @if (isInfoVisible) {
      <div
        #infoPanel
        id="info-panel"
        data-automation-id="info-panel"
        class="info"
        role="region"
        aria-atomic="true"
        aria-describedby="info-panel"
        [ngClass]="{ visible: isInfoVisible, 'left': isLeftAligned }"
        [attr.aria-hidden]="!isInfoVisible"
        (focusout)="handleFocusOut($event)"
        (keydown)="handleKeyDown($event)"
        [innerHTML]="'keyboard_instructions.' + instructionsFor | translate"
      ></div>
    }
  </div>
</div>